(function($){
    'use strict';

    $('.js-ad-carousel').each(function() {
    	var $carousel = $(this);

	    $carousel.slick({
		    autoplay: true,
		    autoplaySpeed: 6000,
		    arrows: false,
		    dots: false,
		    infinite: true,
	    	fade: true,
	    	mobileFirst: true,
		    speed: 600,
	    });
    });
}(jQuery));